<template>
    <div class="step1_mb">
        <v-row align="center" class="my-10 my-sm-15">
            <v-col cols="12" style="position: relative;">
                <div>
                    <h1 :style="{ backgroundImage: 'url(' + homes_jigu + ')' }" class="title-line"></h1>
                    <img :src="homes_step1" class="title-img px-3 px-sm-8">
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="mb-2" style="padding-top: 9px;"><h5 class="subtitle">あなたの「報告したいこと」に<br class="smart_only">ぴったりなテンプレートを選ぼう！</h5></v-col>
        </v-row>
        <v-row class="lsizebtn">
            <v-col cols="6" md="3" class="pa-2 pa-sm-3" v-for="tmp in themes" :key="tmp.id">
                <v-badge
                overlap
                avatar
                color="transparent"
                offset-x="33"
                offset-y="13"
                class="max_width"
                >
                <template v-slot:badge>
                <v-avatar :class="{hidden: currentTmpId !== tmp.id}">
                    <v-img :src=pointImg></v-img>
                </v-avatar>
                </template>
                <img :src="tmp.image" @click.prevent="selectTheme(tmp.id)" class="rounded-lg"
                :class="{selected: currentTmpId === tmp.id,
                notSelected: currentTmpId !== tmp.id}">
                </v-badge>
                <p class="mb-0 mt-2 text-center tmptitle">{{tmp.title}}</p>
            </v-col>
        </v-row>
        <v-row justify="center" style="height: 59px;">
            <div class="translate_down">
                <p class="text-center subtitle pa-0 ma-0 mx-5" style="line-height: 36px;">サンプルイメージ</p>
            </div>
        </v-row>
        <v-row justify="center" align="center" class="bg_bcol tmp_bg mx-md-0">
            <v-img
                :aspect-ratio="1"
                max-height="400"
                max-width="400"
                contain
                :src="themes[currentTmpId].image"
                class="rounded-lg"
                style="width: 100%;"
            ></v-img>
        </v-row>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import template0 from '../assets/template0.jpg';
import template1 from '../assets/template1.jpg';
import template2 from '../assets/template2.jpg';
import template3 from '../assets/template3.jpg';
import point from '../assets/point.svg';
import homes_jigu from '../assets/homes_jigu.svg';
import homes_step1 from '../assets/homes_step1.svg';
export default {
    data(){
        return{
            themes: [
                {
                    id: 0,
                    title: "事務所声明風",
                    image: template0
                },
                {
                    id: 1,
                    title: "事務所声明風(写真付き)",
                    image: template1
                },
                {
                    id: 2,
                    title: "手書き声明風",
                    image: template2
                },
                {
                    id: 3,
                    title: "手書き声明風(写真付き)",
                    image: template3
                },
            ],
            currentTmpId: 1,
            pointImg: point,
            homes_jigu,
            homes_step1
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
    },
    watch: {
    },
    methods: {
        ...mapActions(['selectThemeAction']),
        selectTheme(val){
            if (this.currentTmpId === val) return;
            if ((val === 1 || val === 3) && this.$store.state.image.theme !== val){
                this.$root.$children[0].$refs.thirdStep.delteFile();
            }
            this.currentTmpId = val;
            this.selectThemeAction({
                theme: val
            })
        }
    }
}
</script>

<style scoped>
.max_width{
    max-width: 100%;
}
.translate_down{
    transform: translate(0px, 59px);
    height: 36px;
    background-color: black;
    color: white;
    z-index: 1;
    border-radius: 20px;
}
.notSelected{
    border-style: solid;
    border-width: 1px;
    border-color: #EFEFEF;
}
.selected{
    border-style: solid;
    border-width: 5px;
    border-color: #ed6103;
}
img {
    max-width: 100%;
    height: auto;
    width /***/:auto;
}
.tmp_bg{
    height: 517px;
    margin: 30px 1px 0px;
    border-radius: 4px;
    overflow: hidden;
}
.tmp_bg .v-image{
    overflow: visible;
}
.tmp_bg .v-image::after{
    content: '';
    display: block;
    position: absolute;
    z-index: -2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(168, 68, 0, 0.3), rgba(0, 0, 0, 0) );
    transform-origin: 50% 0;
    transform: translateY(50%) skewY(-45deg) skewX(27deg) scaleY(2);
    transition: transform 1s;
}
.step1_mb{
    margin-bottom: 100px;
}
@media only screen and (max-width: 769px){
    .tmp_bg{
        height: 443px;
        margin: 30px 1px 0px;
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        border-radius: 0px;
    }
    .translate_down{
        transform: translate(0px, 59px);
    }
    .v-image{
        max-width: 355px !important;
        max-height: 355px !important;
    }
    .step1_mb{
        margin-bottom: 60px;
    }
}
</style>